import { useCallback } from 'react';
import useCrud from 'hooks/useCrud';
import { fetchMarketingScenario, PlatformRegionParams } from 'services/api/oms';

function useScenario() {
  return useCrud({
    read: useCallback(
      (params: { scenarioType: Marketing.AllScenarioType } & PlatformRegionParams) => {
        const { scenarioType, ...others } = params;

        return fetchMarketingScenario(scenarioType, others);
      },
      [],
    ),
  });
}

export default useScenario;
